import palette from "./palette";

export default {
  h1: {
    color: palette.text.primary,
    fontWeight: 400,
    fontSize: "35px",
    letterSpacing: "-0.24px",
    lineHeight: "40px",
    fontFamily: '"Poppins", sans-serif',
  },
  h2: {
    color: palette.text.primary,
    fontWeight: 400,
    fontSize: "29px",
    letterSpacing: "-0.24px",
    lineHeight: "32px",
    fontFamily: '"Poppins", sans-serif',
  },
  h3: {
    color: palette.text.primary,
    fontWeight: 400,
    fontSize: "24px",
    letterSpacing: "-0.06px",
    lineHeight: "28px",
    fontFamily: '"Poppins", sans-serif',
  },
  h4: {
    color: palette.text.primary,
    fontWeight: 400,
    fontSize: "20px",
    letterSpacing: "-0.06px",
    lineHeight: "24px",
    fontFamily: '"Poppins", sans-serif',
  },
  h5: {
    color: palette.text.primary,
    fontWeight: 400,
    fontSize: "16px",
    letterSpacing: "-0.05px",
    lineHeight: "20px",
    fontFamily: '"Poppins", sans-serif',
  },
  h6: {
    color: palette.text.primary,
    fontWeight: 400,
    fontSize: "14px",
    letterSpacing: "-0.05px",
    lineHeight: "20px",
    fontFamily: '"Poppins", sans-serif',
  },
  subtitle1: {
    color: palette.text.primary,
    fontSize: "16px",
    letterSpacing: "-0.05px",
    lineHeight: "25px",
    fontFamily: '"Poppins", sans-serif',
  },
  subtitle2: {
    color: palette.text.secondary,
    fontWeight: 400,
    fontSize: "14px",
    letterSpacing: "-0.05px",
    lineHeight: "21px",
    fontFamily: '"Poppins", sans-serif',
  },
  body1: {
    color: palette.text.primary,
    fontSize: "14px",
    letterSpacing: "-0.05px",
    lineHeight: "21px",
    fontFamily: '"Poppins", sans-serif',
  },
  body2: {
    color: palette.text.secondary,
    fontSize: "12px",
    letterSpacing: "-0.04px",
    lineHeight: "18px",
    fontFamily: '"Poppins", sans-serif',
  },
  button: {
    color: palette.text.primary,
    fontSize: "14px",
    fontFamily: '"Poppins", sans-serif',
  },
  caption: {
    color: palette.text.secondary,
    fontSize: "11px",
    letterSpacing: "-0.04px",
    lineHeight: "18px",
    fontFamily: '"Poppins", sans-serif',
  },
  overline: {
    color: palette.text.secondary,
    fontSize: "11px",
    fontWeight: 400,
    letterSpacing: "0.33px",
    lineHeight: "13px",
    textTransform: "uppercase",
    fontFamily: '"Poppins", sans-serif',
  },
  string: {
    color: palette.text.active,
    fontSize: "14px",
    letterSpacing: "-0.05px",
    lineHeight: "21px",
    fontFamily: '"Poppins", sans-serif',
  },
  tableText: {
    fontSize: "12px",
    fontFamily: '"Poppins", sans-serif',
  },
};
